/* global google */
const gMap = document.querySelector('.map-module__init');
const mapPins = document.querySelectorAll('.map-module__pin');

let map;
const markers = [];

const convertGeoJsonPolygonToLatLng = async () => {
  const response = await fetch('/geo.json');

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const geojson = await response.json();

  let latLngArray = [];

  latLngArray = geojson.map((coord) => ({
    lat: coord[1],
    lng: coord[0],
  }));
  return latLngArray;
};

const initialize = (el, mapLat, mapLng, mapZoom) => {
  const mapOptions = {
    zoom: Number(mapZoom),
    center: new google.maps.LatLng(Number(mapLat), Number(mapLng)),
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    styles: [
      {
        stylers: [{ visibility: 'on' }, { saturation: -100 }, { gamma: 0.95 }],
      },
      {
        featureType: 'all',
        elementType: 'labels.text',
        stylers: [{ visibility: 'on' }, { color: '#313131' }, { weight: 0.2 }],
      },
      {
        featureType: 'road',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'on' }],
      },
      {
        featureType: 'water',
        stylers: [{ color: '#99c6dd' }],
      },
      {
        featureType: 'landscape',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'on' }],
      },
      {
        featureType: 'poi',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'on' }],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text',
        stylers: [{ visibility: 'on' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [{ visibility: 'on' }],
      },
      {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ visibility: 'on' }],
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry',
        stylers: [{ gamma: 0.48 }],
      },
      {
        featureType: 'transit.station',
        elementType: 'labels.icon',
        stylers: [{ visibility: 'on' }],
      },
      {
        featureType: 'road',
        elementType: 'geometry.stroke',
        stylers: [{ gamma: 7.18 }],
      },
    ],
  };

  map = new google.maps.Map(el, mapOptions);
  const infoWindow = new google.maps.InfoWindow({ disableAutoPan: true });
  const baseZoom = Number(mapZoom);

  const updateZoom = () => map.setZoom(windowWidth() < breakpointMd ? baseZoom - 1 : baseZoom);
  updateZoom();
  window.addEventListener('resize', updateZoom);

  mapPins.forEach((mapPin) => {
    const pinLat = mapPin.getAttribute('data-markerlat');
    const pinLng = mapPin.getAttribute('data-markerlng');
    const mapPinIcon = mapPin.getAttribute('data-marker');
    const mapCity = mapPin.getAttribute('data-city');
    const infoCard = document.querySelector(`.infowindow-popup.${mapCity}`);
    const region = mapPin.getAttribute('data-region');
    const link = mapPin.getAttribute('data-link');

    const marker = new google.maps.Marker({
      map,
      position: new google.maps.LatLng(pinLat, pinLng),
      icon: mapPinIcon,
      region,
    });

    markers.push(marker);

    marker.addListener('mouseover', () => {
      infoWindow.setContent(infoCard.innerHTML);
      infoWindow.open(map, marker);
    });

    marker.addListener('mouseout', () => {
      infoWindow.close();
    });

    if (link) {
      marker.addListener('click', () => {
        window.location.href = link;
      });
    }
  });
};

const initMap = async () => {
  const mapLat = gMap.getAttribute('data-lat');
  const mapLng = gMap.getAttribute('data-lng');
  const mapZoom = gMap.getAttribute('data-zoom');

  initialize(gMap, mapLat, mapLng, mapZoom);

  const mapSelect = document.querySelector('.map-module__select');
  if (mapSelect) {
    const radios = mapSelect.querySelectorAll('input[name="region"]');
    const regionButtons = mapSelect.querySelectorAll('.map-module__select .dropdown__list-item');
    if (regionButtons) {
      regionButtons.forEach((item) => {
        item.addEventListener('click', () => {
          const checkedRadio = mapSelect.querySelector('input[type="radio"]:checked');
          if (!checkedRadio) {
            return;
          }
          const selectedValue = checkedRadio.id;

          const items = document.querySelectorAll('.locations-list__item');
          items.forEach((item) => {
            item.style.display = item.dataset.id === selectedValue ? 'block' : 'none';
          });
        });
      });
    }

    const outerCoords = [];

    for (let lng = -180; lng <= 180; lng += 10) {
      outerCoords.push({ lat: 90, lng });
    }
    for (let lat = 90; lat >= -90; lat -= 10) {
      outerCoords.push({ lat, lng: 180 });
    }
    for (let lng = 180; lng >= -180; lng -= 10) {
      outerCoords.push({ lat: -90, lng });
    }
    for (let lat = -90; lat <= 90; lat += 10) {
      outerCoords.push({ lat, lng: -180 });
    }

    const innerCoords = await convertGeoJsonPolygonToLatLng();

    innerCoords.reverse();

    const slovenia = new google.maps.Polygon({
      paths: [outerCoords, innerCoords],
      strokeColor: '#000',
      strokeOpacity: 0,
      strokeWeight: 2,
      fillColor: '#17469e',
      fillOpacity: 0.85,
    });

    // Replace `map` with your actual Google Map instance variable
    slovenia.setMap(map);

    radios.forEach((radio) =>
      radio.addEventListener('change', () => {
        markers.forEach((marker) =>
          marker.setMap(marker.region === radio.id || radio.id === 'all-regions' ? map : null),
        );

        const { lat, lng, zoom } = radio.closest('li')?.dataset || {};
        if (lat && lng && zoom) {
          map.panTo(new google.maps.LatLng(Number(lat), Number(lng)));
          const windowWidth = window.innerWidth;
          if (Number(zoom) !== map.getZoom()) {
            if (windowWidth < 1000) {
              map.setZoom(Number(zoom) * 0.8);
            } else {
              map.setZoom(Number(zoom));
            }
          }
        }
      }),
    );
  }
};

if (gMap) {
  initMap();

  document.querySelector('.map-module__reset .btn')?.addEventListener('click', () => {
    const { lat, lng, zoom } = document.querySelector('.map-module__init').dataset;
    map.setCenter({ lat: Number(lat), lng: Number(lng) });
    map.setZoom(Number(zoom));
    markers.forEach((m) => m.setMap(map));
    const checkboxes = document.querySelectorAll('.map-module__select input');
    checkboxes.forEach((item) => {
      item.checked = false;
    });
    document.querySelector('.map-module__select .dropdown__placeholder-text').innerHTML =
      localData.translations.choose_region;
    const items = document.querySelectorAll('.locations-list__item');
    items.forEach((item) => {
      item.style.display = 'block';
    });
  });
}
